// var MODULE_NAME = (function (MODULE_NAME) {
//     MODULE_NAME.init = function(){
//     };
//     return MODULE_NAME;
// }(MODULE_NAME || {}));